/** The stream details drawer's width: 1350px, but no more than 80% of the screen. */
export const WASTE_STREAM_DRAWER_WIDTH = "min(1350px, 80vw)";
